"use client";

import Image from "next/image";
import { Icons } from "@/components/icons";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { serializer } from "@/utils/rich-text-renderer";
import Link from "next/link";
import { usePathname } from "next/navigation";

/* interface IntroProps {
  intro: GetHomeQuery;
} */

export default function Outro({ prices }: any) {
  // TODO: Fix type
  const imageRef = useRef<HTMLImageElement>(null);

  /* useGSAP(() => {
    gsap.to(imageRef.current, {
      duration: 1,
      ease: "power4.inOut",
      scrollTrigger: {
        trigger: home.heroImage?.url || "",
        start: "top top",
        end: "bottom bottom",
        scrub: true,
      },
    });
  }); */

  const renderThis = (prices: any) => {
    return !!(prices.priceTitle && prices.prices.length > 0 && prices.priceImage.url);
  };

  const pathname = usePathname();

  // console.log(pathname);

  const basePage = pathname.split("/")[1];
  let priceColor = "";

  if (basePage == "combisystems") {
    priceColor = "text-[#82BF40]";
  } else if (basePage == "combiplus") {
    priceColor = "text-[#009EE0]";
  } else if (basePage == "combiconnect") {
    priceColor = "text-[#E6007E]";
  }

  if (renderThis(prices)) {
    return (
      <section className="cs-container overflow-hidden">
        <div className="flex flex-row flex-wrap pt-12 md:pt-24 lg:flex-nowrap lg:items-start">
          <div className="flex w-full flex-col sm:w-5/12 md:w-3/12">
            <h2
              className="mb-12 font-extrabold sm:mt-[36px]"
              dangerouslySetInnerHTML={{ __html: prices.priceTitle }}
            ></h2>
            {prices.prices.map((price: any, index: number) => (
              <div key={index} className="mb-12 flex flex-col">
                <div className="flex flex-col items-start">
                  <h4 className={`mb-4 text-4xl font-bold ${priceColor}`}>
                    {price?.prefix && <span className="mr-4 text-2xl font-normal text-foreground">{price.prefix}</span>}
                    {price.price}
                  </h4>
                  <p className="text-base-200 mb-6 text-base leading-relaxed">{price.subtext}</p>
                  {price.checklist.map((checklist: any, index: number) => (
                    <div key={index} className="text-base-200 my-2 flex flex-row text-base leading-relaxed">
                      <div className="mr-4 mt-0.5 [&_svg]:size-5">
                        <Icons.check className="mr-2 mt-4 h-4" />
                      </div>
                      <RichText content={checklist.raw} renderers={serializer} />
                    </div>
                  ))}
                  {price?.button?.link && price?.button?.displayText && (
                    <div className="mt-6 inline">
                      <Link className="button-long relative" href={price.button.link}>
                        <div className="strip"></div>
                        {price.button.displayText}
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="mt-10 w-full sm:mt-0 sm:w-7/12 md:w-9/12">
            <div className="relative flex h-[450px] w-full items-center">
              <Icons.mirrorLine className="absolute left-0 top-0 z-10 h-full w-auto text-primary md:left-3 lg:left-6" />
              <Image
                src={prices.priceImage?.url || ""}
                alt={prices.priceImage?.altText || ""}
                priority
                width={1920}
                height={1080}
                className="ml-5 !h-[374px] !w-[-webkit-fill-available] object-cover md:ml-[30px] md:max-w-[1200px] lg:ml-[43px]"
                style={{ clipPath: "polygon(156px 0%, 100% 0%, 100% 100%, 0% 100%)" }}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
